import { Container, Row, Col } from "react-bootstrap"
import { Link } from "react-router-dom"
import "../components/styles/TopBar.css"

function TopBar() {
  return (
    <div className="top-bar">
      <Container>
        <Row className="align-items-center">
          <Col md={6} className="contact-info d-flex align-items-center">
          <span className="contact-item me-3">
  ✉️  
  <a href="mailto:info@sunshiny.co.in" className="text-decoration-none text-light">
    info@sunshiny.co.in
  </a> 
  | 
  <a href="mailto:sales@sunshiny.co.in" className="text-decoration-none text-light">
    sales@sunshiny.co.in
  </a>
</span>

            <span className="contact-item">
              <span>📞</span> +91 8608598089 | +91 8754472227
            </span>
          </Col>

          <Col md={6} className="d-flex justify-content-end social-links">
  <Link to="https://www.facebook.com/profile.php?id=61558188570189#" target="_blank" className="social-icon">
    <i className="bi bi-facebook"></i>
  </Link>                                                
  <Link to="https://www.instagram.com/sunshinyenterprises/"  target="_blank" className="social-icon">
    <i className="bi bi-instagram"></i>
  </Link>
  <Link to="https://www.linkedin.com/in/sun-shiny-enterprises-schoon-862a78278/"  target="_blank" className="social-icon">
    <i className="bi bi-linkedin"></i>
  </Link>
</Col>

        </Row>
      </Container>
    </div>
  )
}

export default TopBar
